import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container } from "./style";
import U from "../../assets/U.png";
import { Button, Form, Input, Result, message } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { redirectToGoogleSignIn } from "../../utils/cognitoOAuth";

const REGISTER_USER = gql`
  mutation registerUser($input: RegisterUserInput!) {
    registerUser(registerUserInput: $input) {
      message
    }
  }
`;

export default function RegisterPage() {
  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const [registerUser] = useMutation(REGISTER_USER);

  const handleGoogleSignIn = async () => {
    setGoogleLoading(true);
    try {
      await redirectToGoogleSignIn();
    } catch (error) {
      console.error("Google sign-in error:", error);
      message.error(error.message || "Google sign-in failed");
      setGoogleLoading(false);
    }
  };
  const onFinish = async (values) => {
    console.log("Success:", values);
    setLoading(true);
    try {
      const param = {
        name: values.name,
        email: values.email,
        password: values.password,
        roles: ["COACH"],
      };
      await registerUser({ variables: { input: param } });
      setIsSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setLoading(false);
  };

  return (
    <Container>
      <img src={U} alt="U" className="bg-u" />
      <div className="loginPage">
        <div className="loginLogo">
          <div className="logo1">UVITA</div>
          <div className="logo2">PRO</div>
        </div>
        <div className="loginBox">
          <div
            style={{
              textAlign: "center",
              marginBottom: "32px",
              marginTop: "8px",
            }}
          >
            <div
              style={{
                fontSize: "16px",
                color: "#262626",
                fontWeight: 500,
                marginBottom: "8px",
                lineHeight: "1.5",
              }}
            >
              Create your account to start your free trial.
            </div>
            <div
              style={{
                fontSize: "14px",
                color: "#8c8c8c",
                fontWeight: 400,
              }}
            >
              Takes less than 30 seconds.
            </div>
          </div>
          {isSuccess ? (
            <Result
              status="success"
              icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />}
              title="You've signed up!"
              subTitle={
                <span style={{ color: "#666", fontSize: "16px" }}>
                  Please verify your email address.
                </span>
              }
            />
          ) : (
            <>
              <div className="loginBoxTitle">Register</div>
              <Form
                name="loginForm"
                layout="vertical"
                size="large"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please input your name!" },
                  ]}
                >
                  <Input placeholder="Input your name" />
                </Form.Item>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please input your email!" },
                    { type: "email", message: "The input is not valid email" },
                  ]}
                >
                  <Input placeholder="Input your email" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input.Password placeholder="Input your password" />
                </Form.Item>
                <Form.Item
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The new password that you entered do not match!"
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirm your password" />
                </Form.Item>
                <div className="flex-between">
                  <Link to={`/Login`}>
                    <div className="forget-pwd">Sign In</div>
                  </Link>
                  <Link to={`/ResetPwd?type=forget`}>
                    <div className="forget-pwd">Forgot password</div>
                  </Link>
                </div>

                <Form.Item wrapperCol={{ span: 12 }}>
                  <Button
                    type="primary"
                    block
                    loading={loading}
                    htmlType="submit"
                  >
                    Register
                  </Button>
                </Form.Item>
              </Form>

              <div className="divider-container">
                <div className="divider-line"></div>
                <span className="divider-text">OR</span>
                <div className="divider-line"></div>
              </div>

              <div className="google-login-container">
                <Button
                  block
                  size="large"
                  loading={googleLoading}
                  onClick={handleGoogleSignIn}
                >
                  Sign up with Google
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </Container>
  );
}
